import {useSelector, shallowEqual} from 'react-redux';
import {currentRoomData as currentRoomDataSelectorFn} from '../../pages/DetailsPage/selectors';

const useCurrentRoomData = () => {
  const currentRoomData = useSelector(currentRoomDataSelectorFn, shallowEqual);
  return currentRoomData;
};

export default useCurrentRoomData;
